<template>
  <v-card class="props">
    <v-card-title>
      {{ title }}
      <v-tabs v-model="tab" fixed-tabs>
        <v-tabs-slider/>
        <v-tab>Русский</v-tab>
        <v-tab>Казахский</v-tab>
        <v-tab>Английский</v-tab>
      </v-tabs>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-tabs-items v-model="tab">
          <v-tab-item eager v-for="(caption, def) in langs" :key="def">
            <v-text-field
              v-model="newData['title_'+def]"
              :label="`Заголовок пункта (${caption})`"
              :rules="rules['name_'+def]"
            />
            <html-field
              v-model="newData['text_'+def]"
              :toolbar="customToolbar"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn text color="light-green darken-4" @click="save"> Сохранить</v-btn>
    </v-card-actions>
    <snackbar v-bind.sync="snackbar"/>
  </v-card>
</template>

<script>
import Snackbar from "../Snackbar";
import transport from "../../mixins/transport";
import {VueEditor} from "vue2-editor";
import HtmlField from "../InputBlock/HtmlField";

export default {
  name: "Props",
  components: {HtmlField, Snackbar, VueEditor},
  mixins: [transport],
  props: {
    data: {
      type: Object,
      title_ru: String,
      title_en: String,
      title_kk: String,
      text_ru: String,
      text_en: String,
      text_kk: String,
    }
  },
  data() {
    return {
      newData: {},
      tab: 0,
      langs:{
        'ru':'рус',
        'kk':'каз',
        'en':'eng',
      },
      rules: {
        name_ru: [
          (v) => !!v || console.log(this) || this.vError('ru', "Заполните поле"),
          (v) => !v || v.length < 255 || this.vError('ru', "не более 255 символов")
        ],
        name_en: [
          (v) => !!v || console.log(this) || this.vError('en', "Заполните поле"),
          (v) => !v || v.length < 255 || this.vError('en', "не более 255 символов")
        ],
        name_kk: [
          (v) => !!v || console.log(this) || this.vError('kk', "Заполните поле"),
          (v) => !v || v.length < 255 || this.vError('kk', "не более 255 символов")
        ],
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        ["link"]
      ],
      valid: true,
      errors: {
        ru: false,
        en: false,
        kk: false
      },
      nav:['ru','kk','en']
    };
  },
  computed: {
    title() {
      return this.data.id
        ? "Редактирование пункта"
        : "Создание пункта";
    }
  },
  watch: {
    data: {
      immediate: true,
      handler() {
        this.newData = Object.assign({}, this.data);
      }
    }
  },
  methods: {
    vError(div, text) {
      this.errors[div] = true;
      return text;
    },
    navToError() {
      const activeTab = this.nav[this.tab];
      if(this.errors[activeTab])return;
      this.nav.some((tab, i)=>{
        if(this.errors[tab]){
          this.tab = i;
          return true;
        }
        return  false;
      })
    },
    validate() {
      this.errors.ru = this.errors.en = this.errors.kk = false;
      this.$refs.form.validate();
    },
    save() {
      this.validate()
      if (!this.valid) {
        this.navToError();
        return;
      }
      this.$emit('update', this.newData);
    },
  }
};
</script>
<style lang="scss">
.collectionProps {
  .v-card__actions {
    flex-direction: column;
    align-items: flex-end;
  }
}
</style>
